module.exports = __webpack_public_path__ + "img/materials@2x.e9fdfd13.png";